/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const SUPER_ADMIN_CAN_ABILITY = [
  //Route Access
  ["read", "MyProfile"],
  ["read", "DashboardOverview"],
  ["read", "DashboardIssuerAnalysis"],
  ["read", "Masquerader"],
  ["read", "UserList"],
  ["read", "DiscountCouponList"],
  ["read", "CommDisList"],
  ["read", "MasqInvitationWithDiscountTemplate"],
  ["read", "Committe"],
  ["read", "Presentation"],
  ["read", "InventoryView"],
  ["read", "GenerateDiscount"],
  ["read", "DiscountList"],
  ["read", "InviteCommitteMember"],
  ["read", "Invite"],
  ["read", "PaymentFailedFAC"],
  ["read", "InviteMasqueraderPurchase"],
  ["read", "MasqueraderList"],
  ["read", "CommitteList"],
  ["read", "DeletedBox"],
  ["read", "DeletedViewBox"],
  ["read", "PresentationList"],
  ["read", "PresentationInventory"],
  ["read", "OrgProfile"],
  ["read", "SectionOptionInventory"],
  ["read", "InventoryControl"],
  ["read", "MasqueraderReport"],
  ["read", "PurchasedCostume"],
  ["read", "ViewBoxDetails"],
  ["read", "ViewMasqBoxDetails"],
  ["read", "ChangeCostumeOptions"],
  ["read", "MasqViewBox"],
  ["read", "MasqBoxList"],
  ["read", "SwitchSection"],
  ["read", "SectionBasePriceSummary"],
  // ["read", "CommitteReport"],
  ["read", "CommitteMemberReport"],
  ["read", "DiscountInvite"],
  ["read", "CreateMasqBox"],
  ["read", "ZeroPaymentReport"],
  ["read", "PartialPaymentReport"],
  ["read", "FullPaymentReport"],
  ["read", "DiscountReport"],
  ["read", "SalesReport"],
  ["read", "OpenRegister"],
  ["read", "PaymentTransaction"],
  ["read", "ManageOpenRegistration"],
  ["read", "FHPolicy"],
  ["read", "ProfileUpdateStepper"],
  ["read", "AboutMe"],
  ["read", "CostumeInventoryReport"],
  ["read", "SectionOptInvReport"],
  ["read", "PaymentReport"],
  ["read", "DeliveredReport"],
  ["read", "InviteesList"],
  ["read", "PrintLabels"],
  ["read", "ScheduleTable"],
  ["read", "BlackListUsers"],
  ["read", "ShelfList"],
  ["read", "ScheduleList"],
  ["read", "ShelfDetail"],
  ["read", "BoxDetail"],
  ["read", "OTPTemplate"],
  ["read", "MasqInvitationTemplate"],
  ["read", "DiscountCodeTemplate"],
  ["read", "CommitteeInvitationTemplate"],
  ["read", "MasqDownPaymentTemplate"],
  ["read", "DeletedBoxTemplate"],
  ["read", "AdminInvitationTemplate"],
  ["read", "DiscountInviteTemplate"],
  ["read", "CashierInviteTemplate"],
  ["read", "CostumePurchaseInviteTemplate"],
  ["read", "InvoiceTemplate"],
  ["read", "TransferBoxNewUserTemplate"],
  ["read", "TransferBoxOldUserTemplate"],
  ["read", "CommonEmailVerificationTemplate"],
  ["read", "Settings"],
  ["read", "ButtonSettings"],
  ["read", "CreateDiscount"],
  ["read", "ThemeAndLogo"],
  ["read", "PreBookInviteTemplate"],
  ["read", "PreBookDownPaymentEmailTemplate"],
  ["read", "PartialRemainderEmailTemplate"],
  ["read", "UnPaidRemainderEmailTemplate"],
  ["read", "CouponReport"],
  ["read", "CashSupervisorInvitationTemplate"],
  ["read", "SupervisorInvitationTemplate"],
  ["read", "APV2PaymentDetails"],
];

export const SUPER_ADMIN_CANNOT_ABILITY = [
  //Route Access Denial
  //  ["read", "Button"],
  ["read", "Costume"],
  ["read", "CostumeOpenReg"],
  ["read", "OpenRegistrationCostumePage"],
  ["read", "InviteList"],
  ["read", "Purchase"],
];
